import BaseComponent from "../../../../../lib/components/BaseComponent";
import React, {createRef} from "react";
import {Mail, Monitor} from "react-feather";
import CM from "../../../../model/system/CM";
import UpdateCard from "./components/UpdateCard";
import updateImg from "./img/updateImg.png";
import HorizontalLayout from "../../../../../lib/components/layouts/HorizontalLayout";
import {ArrowForward} from "@mui/icons-material";

class Changes extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            theme: CM.get().getTheme(),
        }
    }
    render() {
        let bgDiv;
        if (this.state.theme === CM.STD_DARK) {
            bgDiv = "bg-bg-img-layout-dark";
        } else {
            bgDiv = "bg-bg-img-layout-light";
        }
        return <section className={"w-screen h-screen flex "+bgDiv}>
            <div className={'m-10 p-10 flex flex-col gap-10 bg-cn-color-black rounded-xl backdrop-filter backdrop-blur-lg'}>
                <div className={"w-full flex flex-col-reverse lg:flex-row gap-5 justify-between"}>
                    <div className={"w-full lg:w-2/3"}>
                        <h1 className={"text-5xl pb-5 text-cn-color-white"}>Willkommen zur neuesten Version vom Campaigner 2.1</h1>
                        <p className={"text-lg pb-5 text-cn-color-white"}>Entdecken Sie die neuesten Verbesserungen, die Ihre Arbeit noch effizienter machen.</p>
                        <div className={"w-full flex gap-5"}>
                            <a href="/" className={'py-3 px-5 rounded border-cn-color-primary hover:border-cn-color-primary-hover bg-cn-color-secondary hover:bg-cn-color-secondary-hover text-white text-bold'}>Jetzt loslegen</a>
                            {/*<a href="/" className={'py-3 px-5 text-cn-color-primary hover:text-cn-color-primary-hover text-bold'}>Mehr erfahren</a>*/}
                        </div>
                    </div>
                    <div className={'w-full lg:w-1/3'}>
                        <img src={updateImg} alt="" className={'rounded-md'} />
                    </div>
                </div>

                <div className={'flex flex-col lg:flex-row gap-5 justify-around mt-10 lg:mt-32'}>
                    <UpdateCard title={"Dynamischer Massenmailversand"}
                                description={"Die Empfängerliste wird jetzt über ein Filtersystem erst zum Versandzeitpunkt erstellt und ist dadurch immer aktuell."}>
                        <Mail className={'text-cn-color-primary'} size={36}/>
                    </UpdateCard>
                    <UpdateCard title={"Neues UI mit MUI"}
                                description={"Die gesamte Benutzeroberfläche wurde mit dem MUI-Framework modernisiert und neu aufgebaut."}>
                        <Monitor className={'text-cn-color-primary'} size={36}  />
                    </UpdateCard>
                </div>
                <HorizontalLayout className='mt-4'>
                    <a
                      href="/changelog"
                      className="py-3 px-5 rounded border-cn-color-primary hover:border-cn-color-primary-hover bg-cn-color-secondary hover:bg-cn-color-secondary-hover text-white inline-flex items-center gap-2"
                    >
                        zeige ChangeLogs
                        <ArrowForward fontSize="small" />
                    </a>
                </HorizontalLayout>
            </div>
        </section>;
    }
}

export default Changes;
